// extracted by css-extract-rspack-plugin
module.exports =  {"button":"CharacterButton-RuHA__button"};